import React, { useEffect } from "react";

import { sucessInfoModal } from "../../../utils/functions";
import Modal from "../../../utils/customModal";
import useApi from "../../../hooks/useApi";

const RenderContentModal = ({ title, children, buttons, loading }) => {
  return sucessInfoModal(title, children, buttons, loading);
};

const RenderDefault = ({ loading, onConfirm, onClose }) => (
  <RenderContentModal
    loading={loading}
    title="Eliminación de cuenta"
    buttons={{
      SelBtn: { text: "Sí", action: onConfirm },
      formBtn: { text: "No", action: onClose },
    }}
  >
    <p>
      La inactivación de la cuenta no puede ser reversada y provoca que todas la
      relaciones bajo esta cuenta, pasen a estado inactivo.
      <br></br>
      Esta acción requiere la aprobación de un autorizador.
      <br></br>
      <br></br>
      ¿Está seguro que desea eliminar la cuenta?
    </p>
  </RenderContentModal>
);

const RenderSuccessOrError = ({ loading, onOk, errors }) => (
  <RenderContentModal
    loading={loading}
    title={
      errors?.length ? "Error al eliminar cuenta" : "Eliminación de cuenta"
    }
    buttons={{
      formBtn: { text: "Continuar", action: onOk },
    }}
  >
    {errors?.length ? (
      errors
    ) : (
      <p>Se guardo correctamente pendiente de Aprobación.</p>
    )}
  </RenderContentModal>
);

const DeleteAccountModal = ({
  show,
  onCancel,
  onOk,
  accountId,
  providerId,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [errors, setErrors] = React.useState([]);
  const { postApiCAll } = useApi();

  const onClose = () => {
    onCancel && onCancel();
  };

  const onConfirm = async () => {
    setLoading(true);
    setErrors([]);

    const elements = [{ providerAccountId: accountId, providerId }];
    try {
      await postApiCAll("providers/delete-provider-account", elements, {});
      setIsSuccess(true);
    } catch (error) {
      console.log(error?.response?.data?.notifications);
      const { notifications = [] } = error?.response?.data;

      const newErrors = notifications
        .map((item, index) => {
          return item?.description ? (
            <p key={`text-${index}`}>• {item?.description}</p>
          ) : null;
        })
        .filter((i) => i);

      if (!newErrors.length) {
        newErrors.push(
          <p key="random-key">
            No se pudo realizar la acción, intente más tarde o ponte en contacto
            con nosotros.
          </p>
        );
      }

      setErrors(newErrors);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!show) {
      setLoading(false);
      setIsSuccess(false);
      setErrors([]);
    }
  }, [show]);

  return (
    <Modal show={show}>
      {isSuccess || errors?.length ? (
        <RenderSuccessOrError errors={errors} onOk={onOk} loading={loading} />
      ) : (
        <RenderDefault
          onClose={onClose}
          loading={loading}
          onConfirm={onConfirm}
        />
      )}
    </Modal>
  );
};

export default DeleteAccountModal;
